import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M1.41 1.69L0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.99 6.09V16h9.91zM6.55 4l12 12H21V4z",
  opacity: ".3"
})), 'DesktopAccessDisabledTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DesktopAccessDisabledTwoTone.js
// module id = 3102
// module chunks = 2